import React, {
  useEffect,
  useState,
} from 'react';

import './SiteBannerPopup.css';


const API_URL =
  process.env.REACT_APP_API_URL ||
  'http://localhost:5000';


export default function SiteBannerPopup() {
  const [banners, setBanners] =
    useState([]);

  const [index, setIndex] =
    useState(0);


useEffect(() => {
  const sessionKey = 'siteBannersShown';

  // Уже показывали баннеры
  // в этой вкладке браузера
  if (
    sessionStorage.getItem(
      sessionKey
    )
  ) {
    return;
  }

  fetch(
    `${API_URL}/api/site-banners/active`
  )
    .then((res) => res.json())
    .then(async (data) => {
      if (
        !data?.ok ||
        !Array.isArray(data.banners) ||
        data.banners.length === 0
      ) {
        return;
      }

      // Сначала загружаем изображения,
      // и только потом показываем попап
      const loadedBanners = [];

      for (const banner of data.banners) {
        const imageUrl =
          `${API_URL}${banner.image_url}`;

        const loaded =
          await new Promise(
            (resolve) => {
              const img =
                new Image();

              img.onload = () =>
                resolve(true);

              img.onerror = () =>
                resolve(false);

              img.src =
                imageUrl;
            }
          );

        if (loaded) {
          loadedBanners.push(
            banner
          );
        }
      }

      if (
        loadedBanners.length === 0
      ) {
        return;
      }

      sessionStorage.setItem(
        sessionKey,
        '1'
      );

      setBanners(
        loadedBanners
      );
    })
    .catch((err) => {
      console.error(
        '[SiteBannerPopup]',
        err
      );
    });
}, []);


  function closeBanner() {
    setIndex(
      (current) =>
        current + 1
    );
  }


  const banner =
    banners[index];


  if (!banner) {
    return null;
  }


  const image = (
    <img
      src={`${API_URL}${banner.image_url}`}
      alt={banner.name || 'Баннер'}
      className="site-banner-popup-image"
    />
  );


  return (
    <div className="site-banner-popup-overlay">

      <div className="site-banner-popup-box">

        <button
          type="button"
          className="site-banner-popup-close"
          onClick={closeBanner}
        >
          ×
        </button>


        {banner.link_url ? (
          <a
            href={banner.link_url}
            className="site-banner-popup-image-link"
          >
            {image}
          </a>
        ) : (
          image
        )}


        {banner.link_url &&
          banner.button_text && (

            <div className="site-banner-popup-footer">

              <a
                href={banner.link_url}
                className="site-banner-popup-button"
              >
                {banner.button_text}
              </a>

            </div>

          )}

      </div>

    </div>
  );
}